/**
 * Generated bundle index. Do not edit.
 */
export { MatSortModule, MatSortHeader, MatSortHeaderIntl, MatSort } from './public-api';
//# sourceMappingURL=index.js.map